import { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, MailCheck, AlertCircle } from "lucide-react";
import api, { formatApiError } from "../lib/api";

export function AuthCard({ icon: Icon, title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen grid place-items-center" style={{ background: "linear-gradient(135deg, #fafbfc 0%, #ffffff 100%)" }}>
      <div className="surface p-8" style={{ width: 440, maxWidth: "92vw" }} data-testid={testid}>
        <div className="flex items-center gap-3 mb-6">
          <div className="kpi-icon-clean" style={{ width: 44, height: 44, color: "#111827", background: "#f4c40033", boxShadow: "inset 0 0 0 1px #f4c40066" }}>
            <Icon size={22}/>
          </div>
          <div>
            <h1 className="font-display text-xl font-extrabold" style={{ letterSpacing: "-0.02em" }}>{title}</h1>
            <p className="text-sm text-gray-500 font-semibold">{subtitle}</p>
          </div>
        </div>
        {children}
        <div className="mt-5 text-xs text-center text-gray-500">
          <Link to="/login" className="font-bold text-gray-900 hover:underline" data-testid="back-to-login-link">Volver a iniciar sesión</Link>
        </div>
      </div>
    </div>
  );
}

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "No se pudo enviar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthCard icon={MailCheck} title="Revisa tu correo" subtitle="Solicitud recibida" testid="forgot-sent-card">
        <p className="text-sm text-gray-600 font-semibold" data-testid="forgot-sent-message">
          Si <b>{email}</b> tiene una cuenta, te enviamos un enlace para crear una nueva contraseña.
          El enlace vence en 24 horas. Revisa también la carpeta de spam.
        </p>
      </AuthCard>
    );
  }

  return (
    <AuthCard icon={KeyRound} title="¿Olvidaste tu contraseña?" subtitle="Te enviaremos un enlace a tu correo" testid="forgot-card">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="label-up block mb-1.5">Correo electrónico</label>
          <input type="email" className="text-input w-full" value={email} required autoFocus
                 onChange={(e) => setEmail(e.target.value)} placeholder="tu@sdm.com.do" data-testid="forgot-email-input"/>
        </div>
        {error && (
          <div className="pill bad flex items-center gap-2 w-full" style={{ padding: "8px 12px" }} data-testid="forgot-error">
            <AlertCircle size={14}/> {error}
          </div>
        )}
        <button type="submit" className="btn primary w-full flex items-center justify-center gap-2"
                disabled={loading || !email} data-testid="forgot-submit-btn">
          {loading ? <span className="spinner"/> : null}
          {loading ? "Enviando..." : "Enviar enlace"}
        </button>
      </form>
    </AuthCard>
  );
}
